<template>
    <v-container fluid >
        <v-row class="py-10">
            
  <v-card
    class="mx-auto px-3 pt-3"
    max-width="300"

  >
    <v-img
      class="white--text"
      height="200px"
      src="@/assets/img/doctor.png"
    >
      
    </v-img>

    <v-card-title class="ml-7"><h4>Authorized Experts!</h4></v-card-title>

    <v-card-text class="text--grey font-weight-bold text-center">
        All the registered Doctors and Nutrionlists are Authorized and Expertized in respective Fields.
    </v-card-text>

  </v-card>  <v-card
    class="mx-auto px-3 pt-3"
    max-width="300"

  >
    <v-img
      class="white--text"
      height="200px"
      src="@/assets/img/chat.png"
    >
      
    </v-img>

    <v-card-title ><h4 class="mx-auto">Be Anonymous!</h4></v-card-title>

    <v-card-text class="text--grey font-weight-bold text-center">
       Dont feel ashamed or afraid while asking all your queries,your identity will never be disclosed!
    </v-card-text>

  </v-card>
    <v-card
    class="mx-auto px-3 pt-3"
    max-width="300"

  >
    <v-img
      class="white--text"
      height="200px"
      src="@/assets/img/conversation.png"
    >
      
    </v-img>

    <v-card-title class="ml-7"><h4>Ask the Experienced</h4></v-card-title>

    <v-card-text class="text--grey font-weight-bold text-center">
        Apart from the doctors you can even ask the patients that suffered from similiar conditions and learn from there experiences!
    </v-card-text>

  </v-card>
        </v-row>
    </v-container>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>style